import React, { useState, useEffect } from 'react';

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0, 0, 0, 0.85)', // Dark overlay
    backdropFilter: 'blur(8px)', // Blurs the website behind it
    zIndex: 9999, // Must be on top of EVERYTHING
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modal: {
    backgroundColor: '#ffffff',
    padding: '40px',
    borderRadius: '16px',
    maxWidth: '500px',
    width: '90%',
    textAlign: 'center',
    boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
    border: '1px solid #333',
  },
  title: {
    fontSize: '2rem',
    fontWeight: '900',
    color: '#333',
    marginBottom: '15px',
    textTransform: 'uppercase',
  },
  text: {
    color: '#555',
    fontSize: '1.1rem',
    lineHeight: '1.6',
    marginBottom: '30px',
  },
  buttonGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
  },
  confirmButton: {
    padding: '15px',
    fontSize: '1.2rem',
    fontWeight: 'bold',
    color: '#fff',
    backgroundColor: '#b026ff', // Electric Violet
    border: 'none',
    borderRadius: '50px',
    cursor: 'pointer',
    transition: 'background 0.2s',
  },
  denyButton: {
    padding: '15px',
    fontSize: '1rem',
    fontWeight: 'bold',
    color: '#666',
    backgroundColor: 'transparent',
    border: '2px solid #ddd',
    borderRadius: '50px',
    cursor: 'pointer',
    transition: 'color 0.2s, border-color 0.2s',
  }
};

export default function AgeGate() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // 1. Check if the user has already verified
    const isAdult = localStorage.getItem('foreplay_is_adult');
    
    // 2. If NOT verified, show the gate
    if (isAdult !== 'true') {
      setIsVisible(true);
      // Disable scrolling on the body while gate is open
      document.body.style.overflow = 'hidden';
    }
  }, []);

  const handleConfirm = () => {
    // Save preference so it doesn't ask again
    localStorage.setItem('foreplay_is_adult', 'true');
    setIsVisible(false);
    // Re-enable scrolling
    document.body.style.overflow = 'unset';
  };

  const handleDeny = () => {
    // Redirect them to Google or Disney
    window.location.href = "https://www.google.com";
  };

  if (!isVisible) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <h2 style={styles.title}>Adult Content Warning</h2>
        
        <p style={styles.text}>
          The website you are about to enter contains content intended for adults 
          (18 years of age or older).
        </p>
        
        <p style={{...styles.text, fontSize: '0.9rem', color: '#888'}}>
          By entering, you confirm that you are at least 18 years old and agree to view sexually explicit content.
        </p>

        <div style={styles.buttonGroup}>
          <button 
            style={styles.confirmButton} 
            onClick={handleConfirm}
            className="hover-opacity" // You can add hover effects in CSS
          >
            I am 18 or Older - Enter
          </button>
          
          <button 
            style={styles.denyButton} 
            onClick={handleDeny}
          >
            I am under 18 - Leave
          </button>
        </div>
      </div>
    </div>
  );
}